import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import styles from './AccessAppPermission.css';

class Row extends React.Component {
  render() {
    const { permission, checked, isMokaPayUser } = this.props;
    const logo = require('assets/images/logo-moka-text-white.png');
    const popover = <Popover id="popover">Only available on Moka POS</Popover>;
    return (
      <div className={`${styles['access-app-permission']}`}>
        <div className={'checkbox checkbox-primary'}>
          <input
            type="checkbox"
            id={permission.id}
            onChange={this._onChangeCheckbox}
            checked={checked}
          />
          <label for={permission.id}>{permission.sub_menu_name}</label>
          {isMokaPayUser && !permission.is_allowed_for_moka_pay && (
            <OverlayTrigger placement="top" overlay={popover}>
              <img style={{ marginLeft: '5px' }} src={logo} />
            </OverlayTrigger>
          )}
        </div>
        <div className={styles['access-app-permission-description']}>
          {permission.description}
        </div>
      </div>
    );
  }

  _onChangeCheckbox = () => {
    const { disabled } = this.props;
    if (!disabled) {
      this.props.onChangeCheckbox(this.props.permission);
    }
  };
}

export default Row;
